<div class="container">
    <header class="header-wrapper hide">
        <div class="header px-3  secondary-bg new-secondary-bg">
            <div class="title-area">
                <div class="logo" routerLink="/home">
                    <!-- <img class="siem" src="assets/newLogo5_5.svg"> -->
                    <!-- <img class="siem" src="assets/new_logo.svg"> -->
                    <img class="siem" src="assets/secureInteli_logo_white.svg">
                </div>
                <div class="route-crumps">
                    <ng-container *ngFor="let crump of crumpService.route_crumps; index as i; let lindex = last;let findex = first">
                        <ng-container *ngIf="!findex">
                            <p class="white-text content-xl" [ngClass]="lindex?'':'route-clickable'" (click)="crump_click(crump,i)">{{crump.disp_str}}</p>
                            <p class="white-text content-xl" *ngIf="!lindex"> > </p>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="options-area">
                <div class="menu-user">
                    <!-- <img (click)="openOverlay_click(userMenuRef,userMenuOrigin)" class="profile" src="assets/userprofile.svg"
          tooltip="Profile"> -->

                    <img class="menu-icon icon-l" src="assets/bell.svg">
                    <img class="menu-icon icon-l" src="assets/help.svg">
                </div>
                <div #userMenuOrigin1 class="UserProfile bold-text header-text" (click)="openOverlay_click(userMenuRef,userMenuOrigin1)">

                    <span class="username-icon span-l radius-round white-text logo-bg">{{sharedService.userFName.substring(0, 1) |
            uppercase}}{{sharedService.userLName.substring(0,
            1) | uppercase}}</span>
                    <div class="option">
                        <div class="main">
                            <!-- <span class="username">Welcome {{sharedService.userFName}}</span> -->
                            <span class="username span-l" [tooltip]="sharedService.userFName">{{sharedService.userFName | titlecase}}</span>
                            <span class="customer span-l">@{{sharedService.customer}}</span>
                        </div>

                        <div class="powered-by">
                            <!-- <span>powered by centiyent SIEM</span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </header>
    <header class="header-wrapper">
        <div class="header px-3 pt-3 secondary-bg">
            <div class="title-area">
                <div class="logo" routerLink="/home">
                    <img class="siem" src="assets/newLogo5_5.svg">
                </div>
                <div class="route-crumps">
                    <ng-container *ngFor="let crump of crumpService.route_crumps; index as i; let lindex = last;let findex = first">
                        <ng-container *ngIf="!findex">
                            <p class="white-text content-xl" [ngClass]="lindex?'':'route-clickable'" (click)="crump_click(crump,i)">{{crump.disp_str}}</p>
                            <p class="white-text content-xl" *ngIf="!lindex"> > </p>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="options-area">
                <div class="menu-user">
                    <!-- <img (click)="openOverlay_click(userMenuRef,userMenuOrigin)" class="profile" src="assets/userprofile.svg"
                  tooltip="Profile"> -->

                    <img class="menu-icon icon-l" src="assets/bell.svg">
                    <img class="menu-icon icon-l" src="assets/apps.svg">
                </div>
                <div #userMenuOrigin class="UserProfile bold-text header-text" (click)="openOverlay_click(userMenuRef,userMenuOrigin)">

                    <span class="username-icon span-l radius-round border-light">{{sharedService.userFName.substring(0, 1) |
                    uppercase}}{{sharedService.userLName.substring(0,
                    1) | uppercase}}</span>
                    <div class="option">
                        <div class="main">
                            <!-- <span class="username">Welcome {{sharedService.userFName}}</span> -->
                            <span class="username span-l" [tooltip]="sharedService.userFName">Hello {{sharedService.userFName | titlecase}}</span>
                            <span class="customer span-l">@{{sharedService.customer}}</span>
                        </div>

                        <div class="powered-by">
                            <span>powered by centiyent SIEM</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </header>
    <div class="body-wrapper">
        <ng-container *ngIf="mat_spinner_userProfile_state">
            <div class="body-bottom-spinner">
                <mat-spinner class="spinner" diameter=20></mat-spinner>
            </div>
        </ng-container>
        <div class="body-wrapper-navbar border-light-right primary-bg" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'expanded':'collapse'">
            <div class="navbar-icon-container py-2">
                <div [ngClass]="crumpService.homeIcon.isSelected?'module-selected':'module-deselected'" (click)="navIconclick(crumpService.homeIcon)">
                    <!-- <div class="module-deselected" (click)="navIconclick(crumpService.homeIcon)"> -->
                    <div class="menu-panel-icon">
                        <img [src]="crumpService.homeIcon.img_url" class="module-active icon-l">
                    </div>
                    <span [ngClass]="[crumpService.homeIcon.isSelectable? 'module-active-label menu-label span-l' :'module-inactive-label menu-label span-l' , (sharedService.$sidebarExpanded | async) ? 'menu-label-text':'']">{{crumpService.homeIcon.label}}</span>
                </div>
            </div>
            <div class="navbar-icon-container-2 py-2">
                <ng-container *ngFor="let applist of crumpService.applist|keyvalue:originalOrder">

                    <ng-container *ngIf="crumpService.categoryColums?.includes(applist.key)">
                        <span class="divider my-0 mx-auto border-light-bottom"></span>

                        <div class="navbar-icon-container">
                            <ng-container *ngFor="let nav of applist.value">
                                <!-- <div [ngClass]="nav.isSelected?'module-selected':'module-deselected'" (click)="navIconclick(nav)"> -->
                                <div *ngIf="nav.isSelectable || nav.is_nonselected_menu_visible? true : false" [ngClass]="nav.isSelected && nav.catagory_order? ['module-selected','navbar-category-'+nav.catagory_order,'category-'+nav.catagory_order+'-'+nav.menucolor.color.replace('#','')]: nav.isSelectable ? ['module-deselected','navbar-categoryhover-'+nav.catagory_order]:['module-deselected']"
                                    (click)="navIconclick(nav)">
                                    <div class="menu-panel-icon">
                                        <!-- <img  [ngClass]="nav.isSelectable? 'module-active' :'module-inactive'" [src]="nav.img_url"> -->
                                        <img class="icon-default-color icon-l" [ngClass]="nav.isSelectable && nav.catagory_order? ['category-icon-'+nav.catagory_order,'category-icon-'+nav.catagory_order+'-'+nav.menucolor.color.replace('#','')]:'module-inactive'" [src]="nav.img_url" [style]="nav.menucolor?.filterColor"
                                        />
                                    </div>
                                    <span [ngClass]="[nav.isSelectable? 'module-active-label menu-label span-l' :'module-inactive-label menu-label span-l',(sharedService.$sidebarExpanded | async) ? 'menu-label-text':'']">{{nav.label}}</span>

                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>




        <div class="body-wrapper-navbar border-light-right hide  white-bg" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'expanded':'collapse'">
            <div class="navbar-wrapper ">
                <div class="navbar-top ">
                    <div class="sidebar-items px-4 pt-4 border-light-bottom pb-4 enable-action" (click)="navIconclick(crumpService.homeIcon)" [ngClass]="[(sharedService.$sidebarExpanded | async) == true ? '' : 'center',crumpService.homeIcon.isSelected ? 'selected-list selectable-text' : 'primary-text']">
                        <div class="sidebar-left " [ngClass]="crumpService.homeIcon.isSelected ? 'selected-icon' : ''">
                            <!-- <img class="icon-m" [src]="crumpService.homeIcon.img_url" [tooltip]="crumpService.homeIcon.disp" [ngClass]="(sharedService.$sidebarExpanded | async) ? '' : 'tooltip-enable'"> -->
                            <mat-icon [tooltip]="crumpService.homeIcon.disp" position="right" [ngClass]="(sharedService.$sidebarExpanded | async) ? '' : 'tooltip-enable'">{{crumpService.homeIcon.img_url}}</mat-icon>
                            <p class=" content-m " [ngClass]="[(sharedService.$sidebarExpanded | async) ? 'menu-label-text':'menu-label',crumpService.homeIcon.isSelected ? 'selectable-text bold-text' : 'primary-text bold-text']">{{sharedService.titles.overview}}</p>
                        </div>
                    </div>
                    <ng-container *ngFor="let menuItem of sharedService.menu ; index as i">
                        <div class="sidebar-wrapper" [ngClass]="[i != sharedService.menu.length-1  ? 'border-light-bottom': '',menuItem.expand ? 'pb-3':'']">
                            <div class=" sidebar-items px-4 pt-4 enable-action " (click)="accordianClick(menuItem.value) " [ngClass]="(sharedService.$sidebarExpanded | async) ? 'pb-4' : 'hide' ">
                                <div class="sidebar-left ">
                                    <!-- <img class="icon-m " [src]="menuItem.icon "> -->
                                    <mat-icon>{{menuItem.icon}}</mat-icon>
                                    <p class="primary-text content-m bold-text" [ngClass]="(sharedService.$sidebarExpanded | async) ? 'menu-label-text': 'menu-label center' ">{{menuItem.disp}}</p>
                                </div>
                                <div class="sidebar-right ">
                                    <img class="expanded-arrow icon-m " src="assets/widgets/downarrow.svg " [ngClass]="menuItem.expand ? 'expand-img' : 'collapse-img' ">
                                </div>
                            </div>
                            <div class="result-area" [ngClass]="(sharedService.$sidebarExpanded | async) ?'' : 'pt-4' ">
                                <ng-container *ngIf="menuItem.expand ">
                                    <div class="result-wrapper ">
                                        <ng-container *ngFor="let list of menuItem.list ">
                                            <div class="sidebar-left enable-action py-4" (click)="navIconclick(list)" [ngClass]="[(sharedService.$sidebarExpanded | async) ? 'pl-8':'center',list.isSelectable ? '': 'permission-denied',list.isSelected ? 'selected-list selected-icon' : '']">
                                                <!-- <img class="icon-m " [src]="list.icon " [tooltip]="list.disp" position="right" [ngClass]="(sharedService.$sidebarExpanded | async) ? '' : 'tooltip-enable'"> -->
                                                <mat-icon [tooltip]="list.disp" position="right" [ngClass]="(sharedService.$sidebarExpanded | async) ? '' : 'tooltip-enable'">{{list.icon}}</mat-icon>
                                                <p class=" content-m " [ngClass]="[(sharedService.$sidebarExpanded | async) ? 'menu-label-text': 'menu-label', list.isSelected ? 'selectable-text' : 'primary-text' ]">{{list.disp}}</p>
                                            </div>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="navbar-bottom px-4 enable-action pt-4 border-light-top" (click)="collapseNav()">
                    <img class="navigation-arrow icon-m " src="assets/widgets/downarrow.svg " [ngClass]="(sharedService.$sidebarExpanded | async) ? 'navigation-arrow-expand' : 'navigation-arrow-collapse' ">
                    <p class="primary-text content-l lightest-text " [ngClass]="(sharedService.$sidebarExpanded | async) ? 'menu-label-text': 'menu-label' ">{{sharedService.titles.collapse_nav}}</p>
                </div>
            </div>
        </div>





        <div class="body-wrapper-content primary-bg " [ngClass]="(sharedService.$sidebarExpanded | async) ? 'expanded-body': 'collapsed-body' ">
            <router-outlet></router-outlet>
        </div>

        <ng-template #userMenuRef>
            <div class="user-menu-container primary-bg ">
                <div class="user-menu-wrapper content-l primary-text dropdown-shadow radius-s ">
                    <div class="row-1 menu radius-s p-5 " (click)="openMyProfile_click() ">
                        <!-- <i class="my-profile icon-l "></i> -->
                        <img src="../assets/menuicons/my-profile.svg " class="icon-l ">
                        <span>My Profile</span>
                    </div>
                    <div class="row-3 menu radius-s p-5 " (click)="openResetPassword_click() ">
                        <!-- <i class="reset-password icon-l "></i> -->
                        <img src="../assets/menuicons/reset-password.svg " class="icon-l ">
                        <span>Reset Password</span>
                    </div>
                    <div *ngIf="sharedService.isOrganization " class="menu radius-s p-5 " (click)="openOrganization_click() ">
                        <!-- <i class="changeCustomer icon-l "></i> -->
                        <img src="../assets/menuicons/changeCustomer.svg " class="icon-l ">
                        <span>Change customer</span>
                    </div>
                    <div class="row-4 menu radius-s p-5 " (click)="logout() ">
                        <!-- <i class="logout icon-l "></i> -->
                        <img src="../assets/menuicons/logout.svg " class="icon-l ">
                        <span>Logout</span>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <!-- <footer class="footer-wrapper "> -->
    <!-- <p class="copyright ">&copy;{{footer?.copyright}}</p>
    <p class="version ">{{footer?.version}}</p> -->
    <!-- </footer> -->
</div>